import { getType, getActionCreator } from 'shared/lib';
const prefix = '@@app/news';

export const GET_CARBON_EMISSION = getType(prefix, 'GET_CARBON_EMISSION');
export const getCarbonEmission = getActionCreator(GET_CARBON_EMISSION);

export const GET_CARBON_EMISSION_SUCCESS = getType(
  prefix,
  'GET_CARBON_EMISSION_SUCCESS'
);
export const getCarbonEmissionSuccess = getActionCreator(
  GET_CARBON_EMISSION_SUCCESS
);

export const GET_CARBON_CONTACT = getType(prefix, 'GET_CARBON_CONTACT');
export const getCarbonContact = getActionCreator(GET_CARBON_CONTACT);
